// Styles
import './Notification.scss';

// Libs
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import Button from '@/common/components/atoms/Button/Button';
// Common
import NavLinkExtended from '@/common/components/blocks/NavLinkExtended/NavLinkExtended';
// Constants
import { NOTIFICATIONS_TYPES } from '@/common/constants';
// Assets
import { ReactComponent as CloseIcon } from '@/materiaux/assets/icons/close.svg';

// PropTypes
import {
  NotificationDefaultProps,
  NotificationPropTypes,
} from './Notification.proptypes';
// Hooks
import useNotification from './useNotification';

const Notification = ({
  className,
  datetime,
  disabled,
  entityExists,
  entityId,
  id,
  isLoading,
  isRead,
  message,
  object,
  onClose,
  onRead,
  type,
  typeOrigin,
}) => {
  const { i18n } = useTranslation();

  const {
    classNames,
    isDisabled,
    isLink,
    notificationIcon,
    notificationLink,
    notificationLogo,
  } = useNotification({
    className,
    disabled,
    entityExists,
    isLoading,
    type,
    typeOrigin,
  });

  const Content = () => (
    <div className="notification__content">
      <p className="notification__type">{object}</p>
      <p className="notification__title">{message}</p>
      <p className="notification__date">{i18n.format(datetime, 'ago')}</p>
    </div>
  );

  return (
    <div className={classNames}>
      {notificationIcon}
      {isLink ? (
        <NavLinkExtended
          disabled={isDisabled[type]}
          onClick={onClose}
          to={`${notificationLink}/${entityId}`}
        >
          <Content />
        </NavLinkExtended>
      ) : (
        <Content />
      )}
      <div className="notification__logo">{notificationLogo}</div>
      <div className="notification__actions">
        <Button
          onClick={() => onRead(NOTIFICATIONS_TYPES.ARCHIVE, [id])}
          className="button--with-icon close"
          disabled={isDisabled.disabled}
        >
          <span className="circle">
            <CloseIcon className="icon" />
          </span>
        </Button>
        {!isRead && (
          <Button
            onClick={() => onRead(NOTIFICATIONS_TYPES.READ, [id])}
            className="button--with-icon"
            disabled={isDisabled.disabled}
          >
            <span className="circle">
              <span className="point" />
            </span>
          </Button>
        )}
      </div>
    </div>
  );
};

Notification.defaultProps = {
  ...NotificationDefaultProps,
};

Notification.propTypes = {
  ...NotificationPropTypes,
};

export default Notification;
